enum DataTest {
	'data-flow-switch-direction' = 'data-flow-switch-direction',
}

export default DataTest;
